import ReactDOM from "react-dom/client";
import {
  HashRouter as Router,
  Routes,
  Route,
  
} from "react-router-dom";
import './index.scss';
// import your route components too
import Home from './pages/home/index'
import Doc from './pages/doc/index'
import Ad from './pages/ad/index'
import Rules from './pages/rules/index'

const root = ReactDOM.createRoot(
  document.getElementById("root")
);
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<Home />}>
      </Route>
      <Route path="/doc" element={<Doc />}>
      </Route>
      <Route path="/ad" element={<Ad />}>
      </Route>
      <Route path="/rules" element={<Rules />}>
      </Route>
    </Routes>
  </Router>
);